module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("配置管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.addParent
    }
  }, [_vm._v("新增父级类目")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.parentColumn,
      "data": _vm.parentData,
      "loading": _vm.searchLoading
    }
  })], 1), _vm._v(" "), _c('EditItemModal', {
    attrs: {
      "itemId": _vm.itemId,
      "pid": _vm.pid
    },
    on: {
      "on-close": function($event) {
        _vm.editModal = false
      },
      "on-edilllt-success": _vm.editSuccess,
      "on-edit-clearid": _vm.clearid
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e288708","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminConfigList.vue
// module id = 1915
// module chunks = 8